import React from 'react';
import { Alerts } from '@unimed-fesp/components';

const AlertLiberarAcessoModal = () => {
  return (
    <Alerts type="warning" height={75} width={400} hideIcon>
      <span>
        <p>
          <b>Atenção!</b>É necessário realizar a liberação de acesso para que o
          usuário consiga acessar ao sistema.
        </p>
      </span>
    </Alerts>
  );
};

export default AlertLiberarAcessoModal;
